import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { Link } from 'react-router-dom'
import MetaTitle from '../../Components/UI/MetaTitle'

export const NotFound = (): JSX.Element => {
  return (
    <main className='error-page'>
      <MetaTitle title='Page not found - HeadBox' />
      <Alert severity='warning'>
        <AlertTitle>Page Not Found</AlertTitle>
        Sorry, the page you&#39;re looking for doesn&#39;t seem to exist.{' '}
        <Link to='/'>Return to start</Link>
      </Alert>
    </main>
  )
}
